import type { Namespace, NamespaceFile, NamespaceFileUrl } from './types.js';

export const search: Namespace = import.meta.glob<NamespaceFile>(
    '../locales/*/search.json' satisfies NamespaceFileUrl,
    { eager: true, import: 'default' },
);
